import { pluralRu } from '../../plural';

const matchesWord = (n: number): string => pluralRu(n, 'матч', 'матча', 'матчей');

export const players = {
  status: {
    active: 'Активен',
    banned: 'Забанен'
  },
  reasonQuoted: (reason: string) => `«${reason}»`,
  forever: 'навсегда',
  until: (date: string) => `до ${date}`,
  pagination: {
    back: '← Назад',
    next: 'Вперёд →',
    info: (page: number, totalPages: number, total: number) => `Стр. ${page} / ${totalPages} · всего ${total}`
  },
  tagAssignment: {
    kicker: 'Игрок',
    title: 'Назначение тега',
    assignLabel: 'Назначить тег',
    noTag: 'Без тега',
    save: 'Сохранить тег',
    clear: 'Снять',
    selectHint: 'Выберите игрока в таблице, чтобы назначить или снять тег.',
    failedMarker: 'Не удалось'
  },
  filters: {
    title: 'Игроки',
    total: (n: number) => `${n} всего`,
    namePlaceholder: 'Имя / Steam',
    banned: 'Забаненные',
    active: 'Активные'
  },
  table: {
    player: 'Игрок',
    rating: 'Рейтинг',
    matches: 'Матчи',
    total: 'всего',
    tag: 'Тег',
    status: 'Статус',
    loading: 'Загружаю игроков...',
    empty: 'Игроки по текущим фильтрам не найдены.',
    next: 'Дальше',
    summary: (page: number, totalPages: number, remaining: number, total: number) =>
      `Страница ${page} / ${totalPages}, осталось ${remaining}, всего ${total}`
  },
  profile: {
    weekdaysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    ongoing: 'идёт',
    durationHoursMinutes: (hours: number, minutes: number) => `${hours}ч ${minutes}м`,
    durationMinutes: (minutes: number) => `${minutes}м`,
    justNow: 'только что',
    minutesAgo: (minutes: number) => `${minutes} мин назад`,
    hoursAgo: (hours: number) => `${hours} ч назад`,
    daysAgo: (days: number) => `${days} дн назад`,
    monthsAgo: (months: number) => `${months} мес назад`,
    yearsAgo: (years: number) => `${years} ${pluralRu(years, 'год', 'года', 'лет')} назад`,
    trend7d: (delta: number) => `${delta > 0 ? '+' : ''}${delta} за 7 дней`,
    noChange7d: 'без изменений за 7 дней',
    ratingKicker: (mode: string) => `Рейтинг ${mode}`,
    ratingKickerUpper: (mode: string) => `РЕЙТИНГ ${mode}`,
    rankInMode: (rank: number, mode: string) => `#${rank} в ${mode}`,
    wins: 'побед',
    top3: 'топ-3',
    weekTitle: 'За неделю',
    weekMatches: (n: number) => `${n} ${matchesWord(n)}`,
    weekAvgPlace: (place: string) => ` · ср. место ${place}`
  },
  detail: {
    copyTitle: (label: string) => `Скопировать ${label}`,
    loadingShort: 'Загружаю...',
    topListEmptyDescription: 'Данные появятся после первых матчей.',
    matchesCount: (n: number) => `${n} ${matchesWord(n)}`,
    stateUnavailable: 'Состояние недоступно',
    live: 'идёт',
    playersCount: (n: number) => `${n} игроков`,
    activeMatch: 'Активный матч',
    round: (round: number) => ` · Раунд ${round}`,
    yourHero: 'Ваш герой',
    place: (place: number) => ` · ${place} место`,
    openMatch: 'Открыть матч',
    copyId: 'Скопировать ID',
    loadingPlayer: 'Загружаю карточку игрока...',
    loadErrorTitle: 'Ошибка загрузки',
    toSearch: 'К поиску игроков',
    notFound: 'Игрок не найден',
    notFoundDescription: 'Проверьте UID или откройте игрока из списка.',
    backToSearch: '← К поиску игроков',
    fetchFailed: 'Не удалось загрузить карточку игрока.',
    tagsLoadFailed: 'Не удалось загрузить теги.',
    noSubscription: 'Без подписки',
    vipBadge: 'VIP',
    vipBadgeTitle: 'VIP-подписчик',
    subscription: 'Подписка',
    subscriptionUntil: (date: string) => `Подписка до ${date}`,
    inMatch: (id: string) => `В матче · #${id}`,
    balance: 'Баланс',
    lastSeen: 'Был в игре',
    joined: (date: string) => `С нами с ${date}`,
    steamProfile: 'Steam профиль',
    bansCount: (n: number) => `Банов ${n}`,
    lastBan: (date: string) => ` · последний ${date}`,
    noBans: 'Банов не было',
    kpiTotalMatches: 'Всего матчей',
    kpiAvgPlace: 'Среднее место',
    kpiAvgRounds: 'Ср. раундов',
    favHeroes: 'Любимые герои',
    favAbilities: 'Любимые способности',
    recentMatches: 'Последние матчи',
    allMatches: 'Все матчи →',
    loadingMatches: 'Загружаю матчи...',
    noMatches: 'Нет матчей',
    noMatchesDescription: 'Этот игрок ещё не сыграл ни одного матча.',
    banned: 'Игрок забанен.',
    unbanned: 'Бан снят.'
  },
  vipReminder: {
    expiresToday: 'VIP истекает сегодня',
    expiresIn: (days: number) => `VIP истекает через ${days} дн.`,
    expired: (days: number) => `VIP истёк ${days} дн. назад`,
    hintExpiring: 'Продлите подписку, чтобы не потерять бонусы.',
    hintExpired: 'Продлите подписку, чтобы вернуть бонусы.',
    renew: 'Продлить'
  },
  moderation: {
    kicker: 'Модерация',
    menu: 'Действия модератора',
    assignTag: 'Назначить тег',
    ban: 'Забанить',
    unban: 'Снять бан',
    banHistory: 'История банов',
    subscriptionActivate: 'Активировать подписку',
    subscriptionExtend: 'Продлить подписку',
    subscriptionRevoke: 'Снять подписку'
  },
  revokeSubscriptionModal: {
    kicker: 'Действие',
    title: 'Снять подписку',
    confirmPrefix: 'Снять подписку с игрока',
    confirmSuffix: '?',
    activeUntil: (date: string) => `Сейчас она действует до ${date}.`,
    submit: 'Снять подписку',
    submitting: 'Снимаю…',
    failed: 'Не удалось снять подписку.',
    done: 'Подписка снята.'
  },
  subscriptionModal: {
    dialogLabel: 'Подписка игрока',
    titleActivate: (name: string) => `Активировать подписку: ${name}`,
    titleExtend: (name: string) => `Продлить подписку: ${name}`,
    statusActive: (date: string) => `Подписка активна до ${date}`,
    statusNone: 'Подписки нет',
    duration: 'Срок',
    durationLabel: 'Срок подписки',
    customUntil: 'Подписка до',
    submitActivate: 'Активировать',
    submitExtend: 'Продлить',
    submitting: 'Сохраняю…',
    failed: 'Не удалось изменить подписку.',
    done: 'Подписка обновлена.',
    presets: {
      day7: '7 дней',
      day30: '30 дней',
      day90: '90 дней',
      custom: 'До даты'
    }
  },
  tagModal: {
    currentTag: 'Текущий тег',
    notAssigned: 'не назначен',
    clearTag: 'Снять тег',
    playerNotFound: 'Игрок не найден.',
    assigning: 'Назначаю тег...',
    clearing: 'Снимаю тег...',
    updated: 'Тег обновлён.',
    cleared: 'Тег снят.',
    updateFailed: 'Не удалось обновить тег игрока.'
  },
  banModal: {
    dialogLabel: 'Бан игрока',
    title: (name: string) => `Забанить ${name}`,
    reason: 'Причина',
    reasonPlaceholder: 'Например: читы, оскорбления в чате',
    duration: 'Срок',
    durationLabel: 'Срок бана',
    customUntil: 'Забанен до',
    submit: 'Забанить',
    submitting: 'Баню…',
    failed: 'Не удалось забанить игрока.',
    presets: {
      day1: '1 день',
      day3: '3 дня',
      day7: '7 дней',
      day30: '30 дней',
      forever: 'Навсегда',
      custom: 'До даты'
    }
  },
  unbanModal: {
    kicker: 'Действие',
    title: 'Снять бан',
    confirmPrefix: 'Снять бан с игрока',
    confirmSuffix: '?',
    submit: 'Снять бан',
    submitting: 'Снимаю…',
    failed: 'Не удалось снять бан.'
  },
  banHistory: {
    heading: (name: string) => `История банов — ${name}`,
    loading: 'Загружаю историю...',
    errorTitle: 'Ошибка загрузки',
    emptyTitle: 'Банов не было',
    emptyDescription: 'У игрока ещё не было банов.',
    status: {
      ACTIVE: 'Активен',
      EXPIRED: 'Истёк',
      UNBANNED: 'Снят',
      REPLACED: 'Заменён'
    },
    bannedBy: (by: string, at: string) => `Забанил ${by} · ${at}`,
    unbannedBy: (by: string, at: string) => `Снял ${by} · ${at}`,
    replacedBy: (by: string, at: string) => `Заменил новым баном ${by} · ${at}`,
    loadMore: 'Показать ещё',
    loadingMore: 'Загружаю…',
    failed: 'Не удалось загрузить историю банов.'
  },
  list: {
    title: 'Игроки',
    searchPlaceholder: 'Имя или uid...',
    searchAria: 'Поиск по имени или uid',
    statusAria: 'Статус',
    statusAll: 'Статус: Все',
    everBannedAria: 'История банов',
    everBannedAll: 'Баны: Все',
    everBanned: 'Банились',
    neverBanned: 'Не банились',
    modeAria: 'Режим',
    modeTitle: 'Рейтинг и матчи показываются по выбранному режиму',
    mode: (label: string) => `Режим: ${label}`,
    resetFilters: 'Сбросить фильтры',
    sortAria: 'Сортировка',
    sort: {
      ratingDesc: 'Сорт: Рейтинг ↓',
      ratingAsc: 'Сорт: Рейтинг ↑',
      matchesDesc: 'Сорт: Матчи ↓',
      matchesAsc: 'Сорт: Матчи ↑',
      balanceDesc: 'Сорт: Баланс ↓',
      balanceAsc: 'Сорт: Баланс ↑',
      nameAsc: 'Сорт: Имя ↑',
      nameDesc: 'Сорт: Имя ↓'
    },
    topTitle: 'ТОП РЕЙТИНГА НЕДЕЛИ',
    fullTop: 'Полный топ →',
    found: (n: number) => `Найдено ${n} игроков`,
    pageOf: (page: number, totalPages: number) => `страница ${page} из ${totalPages}`,
    columns: {
      rank: 'Место',
      player: 'Игрок',
      tags: 'Теги',
      status: 'Статус',
      subscription: 'Подписка',
      rating: 'Рейтинг',
      matches: 'Матчей',
      balance: 'Баланс'
    },
    sortByRating: 'Сортировать по рейтингу',
    sortByMatches: 'Сортировать по матчам',
    sortByBalance: 'Сортировать по балансу',
    loadingAria: 'Загрузка игроков',
    errorTitle: 'Ошибка загрузки',
    emptyTitle: 'Игроки не найдены',
    emptyDescription: 'Попробуйте изменить фильтры',
    loadFailed: 'Не удалось загрузить игроков.',
    openProfileAria: (name: string) => `Открыть профиль ${name}`,
    profileAria: (name: string) => `Профиль ${name}`,
    matchesCount: (n: number) => `${n} матчей`,
    noTag: 'без тега',
    you: 'ты',
    subscriptionActive: 'Активна',
    subscriptionNone: 'Нет',
    profile: 'Профиль',
    actionsAria: 'Действия',
    openProfile: 'Открыть профиль',
    banTrigger: 'Бан',
    wasBanned: (n: number) => `был в бане ×${n}`,
    banNow: 'Сейчас:',
    banSummary: (count: number, lastDate: string) => `Банов: ${count} · последний: ${lastDate}`
  },
  statistics: {
    title: 'Статистика',
    modeAll: 'Все режимы',
    playerFilterAll: 'Игрок: Все',
    playerFilterTitle: 'TODO Phase 2: фильтр по игроку',
    errorTitle: 'Ошибка загрузки',
    loadFailed: 'Не удалось загрузить статистику.',
    totalMatches: 'Всего матчей',
    perSeason: 'за сезон',
    topHeroes: 'Топ героев',
    topAbilities: 'Топ способностей',
    byBanRate: 'по ban rate',
    byPickRate: 'по pick rate',
    columns: {
      name: 'Название',
      matches: 'Матчей',
      bans: 'Банов',
      picks: 'Пиков',
      avgPlace: 'Ср. место'
    },
    loadingAria: 'Загрузка статистики',
    emptyDescription: 'Нет данных для выбранного режима.',
    topItems: 'Топ предметов',
    itemsSub: 'по всем режимам',
    itemsLoadFailed: 'Не удалось загрузить статистику предметов.',
    detail: {
      back: '← К статистике',
      kind: { hero: 'Герой', ability: 'Способность', item: 'Предмет' },
      kpi: { matches: 'Матчей', pickRate: 'Pick rate', avgPlace: 'Ср. место', avgRounds: 'Ср. раундов' },
      sections: {
        items: 'Популярные предметы',
        abilities: 'Популярные способности',
        heroes: 'На каких героях берут чаще'
      },
      columns: {
        share: {
          hero: 'Доля матчей героя',
          ability: 'Доля матчей способности',
          item: 'Доля матчей предмета'
        },
        avgPlace: {
          hero: 'Ср. место с этим героем',
          ability: 'Ср. место с этой способностью',
          item: 'Ср. место с этим предметом'
        }
      },
      loadingAria: 'Загрузка детальной статистики',
      emptyEntries: 'Пока нет данных.',
      errorTitle: 'Ошибка загрузки',
      loadFailed: 'Не удалось загрузить детальную статистику.',
      notFoundTitle: 'Ничего не найдено',
      notFoundDescription: 'Для этого названия нет статистики: возможно, ссылка устарела.',
      recentMatches: {
        title: 'Последние матчи',
        columns: { date: 'Дата', type: 'Режим', player: 'Игрок', place: 'Место', rating: 'Рейтинг', match: 'Матч' },
        matchLink: (matchId: string) => `Матч #${matchId}`,
        unknownPlayer: (uid: string) => `Игрок ${uid}`,
        loadingAria: 'Загрузка последних матчей',
        emptyDescription: 'Завершённых матчей с этим героем пока нет.',
        loadFailed: 'Не удалось загрузить последние матчи.'
      }
    }
  },
  banPresets: {
    title: 'Пресеты банов',
    readOnly: 'Редактирование пресетов недоступно',
    loadFailed: 'Не удалось загрузить данные кабинета.',
    slotsUsed: (n: number, max: number) => `${n} из ${max}`,
    slotsAria: (n: number, max: number) => `Занято слотов: ${n} из ${max}`,
    listAria: 'Список пресетов',
    rowReorderTitle: 'Alt+↑/↓ — поменять порядок',
    rowAria: (position: number, name: string) => `Пресет ${position}: ${name}`,
    unnamed: 'Без названия',
    emptyPreset: 'Пустой',
    heroesCount: (n: number) => `${n} ${pluralRu(n, 'герой', 'героя', 'героев')}`,
    abilitiesCount: (n: number) => `${n} ${pluralRu(n, 'способность', 'способности', 'способностей')}`,
    newPreset: 'Новый пресет',
    newPresetName: 'Новый пресет',
    railHint: 'В фазе банов пресеты появляются в этом же порядке — перетащите, чтобы поменять. Один клик банит весь набор.',
    nameLabel: 'Название пресета',
    namePlaceholder: 'Название пресета',
    duplicate: 'Дублировать',
    delete: 'Удалить',
    copyName: (name: string) => `${name} (копия)`,
    deleteConfirm: (name: string) => `Удалить пресет «${name}»?`,
    heroesTitle: 'Герои',
    abilitiesTitle: 'Способности',
    clear: 'Очистить',
    clearAria: (title: string) => `Очистить: ${title}`,
    emptyHeroes: 'Выберите героев в каталоге ниже',
    emptyAbilities: 'Выберите способности в каталоге ниже',
    orderHint: 'Порядок — это приоритет: перетащите иконку, чтобы поменять. В игре сначала банятся первые по лимиту, остальные — если первых уже кто-то забанил.',
    orderHintKeys: 'С клавиатуры: Alt+←/→.',
    priorityAria: (position: number, name: string) => `Приоритет ${position}: ${name}`,
    removeAria: (name: string) => `Убрать ${name}`,
    catalogTabsAria: 'Каталог',
    catalogHeroes: 'Герои',
    catalogAbilities: 'Способности',
    searchLabel: 'Поиск по каталогу',
    searchPlaceholder: 'Поиск по названию',
    onlySelected: 'Только в пресете',
    nothingFound: 'Ничего не найдено',
    emptyTitle: 'Пресетов пока нет',
    emptyDescription: 'Создайте первый пресет: в фазе банов он появится в панели быстрого выбора.',
    emptyReadOnly: 'Пресетов пока нет.',
    unsavedChanges: 'Есть несохранённые изменения',
    revert: 'Отменить',
    save: 'Сохранить',
    saving: 'Сохранение...',
    blankName: (position: number) => `Укажите название пресета №${position}`,
    saved: 'Сохранено',
    saveFailed: 'Ошибка при сохранении.'
  }
};
